import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Add an interceptor to update the headers before each request
api.interceptors.request.use(
    (config) => {
        const tokenKey = config.vendorToken || 'authToken';
        const token = localStorage.getItem(tokenKey);
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            if (config.useMultipart) {
                config.headers['Content-Type'] = 'multipart/form-data';
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Add response interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const originalRequest = error.config;
            //  If request was not vendor request ,clear main tokens
            if (!originalRequest.vendorToken) {
                localStorage.removeItem("authToken");
                localStorage.removeItem("selectedRole");
            } else {
                // Vendor token expired, handle vendor-specific case
                localStorage.removeItem(originalRequest.vendorToken);
            }
        }
        return Promise.reject(error);
    }
);

export default api;
